import { ISchedule } from '../schedule';
import { ISession, MultipleCommunications } from '../session';

export interface IEpxGenericSchedule extends ISchedule {
  activityAlertThreshold?: number | null;
}

export enum SessionType {
  Regular = 'r',
  Symptom = 's',
  Medication = 'm',
  Activity = 'a',
  ESRD = 'esrd',
  ESRDSymptom = 'esrd-s',
  ESRDMed = 'esrd-m',
  Binary = 'b',
  BinaryActivity = 'ba'
}

export interface IEpxGeneric
  extends ISession<IEpxGenericSchedule>, MultipleCommunications {
  type: SessionType;
  isProactive: boolean;
  hasIssues?: boolean;
  symptoms?: string[];
  isTakingMeds?: boolean;
  notTakingReason?: string;
  activityLevel?: number;
  hasWorseActivityLevel?: boolean;
}
